import { render, staticRenderFns } from "./VideoTraining.vue?vue&type=template&id=3759ef8c"
import script from "./video-training.js?vue&type=script&lang=js&external"
export * from "./video-training.js?vue&type=script&lang=js&external"
import style0 from "./VideoTraining.vue?vue&type=style&index=0&id=3759ef8c&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins/jenkins_workspace/workspace/vuejs-tb-train-ontraining-web-sim/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3759ef8c')) {
      api.createRecord('3759ef8c', component.options)
    } else {
      api.reload('3759ef8c', component.options)
    }
    module.hot.accept("./VideoTraining.vue?vue&type=template&id=3759ef8c", function () {
      api.rerender('3759ef8c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/video-training/VideoTraining.vue"
export default component.exports